import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Gallery.css";

const Gallery = ({ mediaItems }) => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  // Safe YouTube embed converter
  const getEmbedUrl = (url) => {
    if (!url) return "";
    try {
      if (url.includes("youtu.be/")) {
        const id = url.split("youtu.be/")[1].split("?")[0];
        return `https://www.youtube.com/embed/${id}`;
      }
      if (url.includes("watch?v=")) {
        const id = url.split("watch?v=")[1].split("&")[0];
        return `https://www.youtube.com/embed/${id}`;
      }
      if (url.includes("/shorts/")) {
        const id = url.split("/shorts/")[1].split("?")[0];
        return `https://www.youtube.com/embed/${id}`;
      }
      return url;
    } catch {
      return url;
    }
  };

  if (!mediaItems || mediaItems.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="p-4 bg-white rounded-3 border d-inline-block">
          <i className="fa-solid fa-images text-teal fs-3 mb-2 d-block"></i>
          <p className="text-muted mb-0">No media items published in the gallery yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-component">
      <div className="row g-4">
        {mediaItems.map((item) => (
          <div key={item.id} className="col-lg-4 col-md-6">
            <div className="gallery-card-modern medical-card h-100">
              {item.content_type === "photo" ? (
                <div
                  className="gallery-photo-wrapper cursor-pointer"
                  onClick={() => setSelectedPhoto(item.photo)}
                >
                  <img
                    src={item.photo}
                    alt={item.title || `Gallery Item ${item.id}`}
                    loading="lazy"
                    className="gallery-photo-img"
                  />
                  <div className="gallery-photo-overlay">
                    <span className="gallery-zoom-icon">
                      <i className="fa-solid fa-magnifying-glass-plus"></i>
                    </span>
                  </div>
                </div>
              ) : (
                <div className="gallery-video-wrapper">
                  <iframe
                    src={getEmbedUrl(item.youtube_link)}
                    title={item.title || `Video ${item.id}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                    className="gallery-iframe"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Enlarged Photo Modal */}
      <Modal
        show={!!selectedPhoto}
        onHide={() => setSelectedPhoto(null)}
        centered
        size="lg"
        contentClassName="bg-transparent border-0"
      >
        <div className="text-end mb-2">
          <button
            type="button"
            className="btn btn-close btn-close-white"
            onClick={() => setSelectedPhoto(null)}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body p-0 text-center">
          {selectedPhoto && (
            <img
              src={selectedPhoto}
              alt="Enlarged gallery preview"
              className="img-fluid rounded-3 shadow-lg"
              style={{ maxHeight: "85vh" }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Gallery;